import React from "react";
import { TimerIcon } from "lucide-react";
import { useLoopingCountdown } from "../hooks/useLoopingCountdown";
type CountdownTimerProps = {
  tone?: "dark" | "light";
  label?: string;
};
const TOTAL_SECONDS = 17 * 60 + 34;
export function CountdownTimer({
  tone = "dark",
  label = "This special offer ends in"
}: CountdownTimerProps) {
  const {
    hours,
    minutes,
    seconds
  } = useLoopingCountdown(TOTAL_SECONDS);
  const units = [{
    value: hours,
    label: "Hours"
  }, {
    value: minutes,
    label: "Min"
  }, {
    value: seconds,
    label: "Sec"
  }];
  const isDark = tone === "dark";
  return <div className="mx-auto w-full max-w-md text-center" role="timer" aria-live="off" data-id="element-18" data-mp="1ac7jerjeruxu">
      <p className={`mb-3 flex items-center justify-center gap-2 text-sm font-bold uppercase tracking-wide ${isDark ? "text-gold-400" : "text-danger"}`} data-id="element-19" data-mp="15dw9yhx0zmg5">
        <TimerIcon className="h-4 w-4" aria-hidden="true" data-id="element-20" data-mp="2zrnptz5y72k1" />
        {label}
      </p>
      <div className="flex items-start justify-center gap-2" data-id="element-21" data-mp="2zpui0gjlmcag">
        {units.map((u, i) => <React.Fragment key={u.label} data-id="element-22" data-mp="1c2rkvgluo72u" data-mpi={i}>
            <div className={`flex w-[84px] flex-col items-center rounded-xl py-2.5 ${isDark ? "bg-white/10 ring-1 ring-white/15" : "bg-navy-900"}`} data-id="element-23" data-mp="1h01mdumik971">
              <span className="font-display text-4xl font-black tabular-nums leading-none text-white" data-id="element-24" data-mp="172n55ssrngdo">
                {String(u.value).padStart(2, "0")}
              </span>
              <span className="mt-1.5 text-[11px] font-semibold uppercase tracking-wider text-white/70" data-id="element-25" data-mp="1zpzsi56r3s81">
                {u.label}
              </span>
            </div>
            {i < units.length - 1 && <span className={`pt-2 font-display text-3xl font-black ${isDark ? "text-white/50" : "text-navy-900/40"}`} aria-hidden="true" data-id="element-26" data-mp="1pzy75l5s8nwt">
                :
              </span>}
          </React.Fragment>)}
      </div>
    </div>;
}